import { SiteHeader } from '../components/SiteHeader'
import { Footer } from '../components/Footer'
import { Button } from '../components/Button'
import styles from './NotFoundPage.module.css'

export function NotFoundPage() {
  return (
    <div className={styles.page}>
      <SiteHeader />
      <main id="main-content" className={styles.main}>
        <p className={styles.code}>404</p>
        <h1 className={styles.title}>This page wandered off.</h1>
        <p className={styles.copy}>
          The page you&rsquo;re looking for doesn&rsquo;t exist or has moved.
        </p>
        <Button to="/" variant="primary" size="lg">
          Back to home
        </Button>
      </main>
      <Footer />
    </div>
  )
}
